import { Collapse } from "antd";
import React from "react";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import { resetForm } from "../../../../../redux/ducks/EditableTable";
import { setRefreshWorkCosts, setRefreshWorkCostsTotals } from "../../../../../redux/ducks/ProjectManagement";
import BillingPlan from "./billingPlan/BillingPlan";
import GanttView from "./gantt/GanttView";
import Invoice from "./Invoice";
import WorkCosts from "./WorkCosts";

const Planning = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();

  const initData = (key) => {
    if (!key) return;
    key = key[0];
    dispatch(resetForm());
    if (key === "1") {
      dispatch(setRefreshWorkCosts(true));
      dispatch(setRefreshWorkCostsTotals(true));
    }
  };

  const items = [
    {
      key: 1,
      label: t("projectsManagement.planning.workCosts"),
      className: "mb-1em",
      children: <WorkCosts />,
    },
    {
      key: 2,
      label: t("projectsManagement.planning.PF&VP"),
      className: "mb-1em",
      children: <BillingPlan />,
    },
    {
      key: 3,
      label: t("projectsManagement.planning.invoicesIssued"),
      className: "mb-1em",
      children: <Invoice />,
    },
    {
      key: 4,
      label: t("projectsManagement.planning.gantt"),
      className: "mb-1em",
      children: <GanttView />,
    },
  ];

  return (
    <>
      <Collapse items={items} accordion destroyOnHidden onChange={(key) => initData(key)} />
    </>
  );
};

export default Planning;
